module.exports = __webpack_public_path__ + "img/IMG-20200902-WA0007.e1f1c447.jpg";